import {ConsoleAPI, Create_Default_User_Api, Create_FeatureConfig_Api} from '../config';
import { Console_User_Api } from '../config';


export const CreateCustomerApi = ConsoleAPI+'/createCustomer';
export const getCustomersApi = ConsoleAPI+'/getCustomers';
export const disableCustomerApi = ConsoleAPI+'/changeCustomerStatus';
export const createDatabaseApi =  ConsoleAPI+'/createDb';
export const createFeatureConfigApi =  Create_FeatureConfig_Api + '/v1/featureConfig';
export const createUserApi = Console_User_Api+'/createUser';
export const createDefaultUserApi = Create_Default_User_Api+'/register-user';
export const getCustomerInfoApi = ConsoleAPI+'/getCustomer';
export const updateCustomerApi = ConsoleAPI+'/updateCustomer';
export const createConfigApi = ConsoleAPI+'/createKalturaConfig';
export const getConfigApi = ConsoleAPI+'/getKalturaConfig';
export const updateConfigApi = ConsoleAPI+'/updateKalturaConfig';
export const maintenanceApi = ConsoleAPI + '/maintenance'
export const getHealthMatrixApi = ConsoleAPI + '/getHealthCheck'